<template>
  <i-modal :title="LANG.history">
    <ModalHistoryContent :nodeId="document.nodeId"/>

    <template #footer>
      <div>
        <i-button variant="secondary" @click.prevent="$emit('update:show', false)">{{ LANG.cancel }}</i-button>
      </div>
    </template>
  </i-modal>
</template>

<script>
import { mapState } from 'vuex';
import ModalHistoryContent from './ModalHistoryContent.vue';

export default {
  components: {
    ModalHistoryContent,
  },
  props: {
    document: {
      default: () => ({}),
      type: Object,
    },
  },
  data() {
    return { };
  },
  computed: {
    ...mapState(['LANG']),
  },
};
</script>
